import {addCircleSvg as Icon__small__addCircleSvg} from '../Icon__small/Icon__small--addCircle.js'

export var addCircle = {
  name: 'addCircle',
  category: 'icon',
  colorable: true,
  svg: Icon__small__addCircleSvg,
};
